import { render, staticRenderFns } from "./PartnerNotInformed.vue?vue&type=template&id=22086662"
import script from "./PartnerNotInformed.vue?vue&type=script&lang=js"
export * from "./PartnerNotInformed.vue?vue&type=script&lang=js"
import style0 from "./PartnerNotInformed.vue?vue&type=style&index=0&id=22086662&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports